import request from '@/utils/request'


// 查询商品信息列表
export function listGoodsInfo(query) {
  return request({
    url: '/goods/goods/info/list',
    method: 'get',
    params: query
  })
}

// 查询商品信息分页
export function pageGoodsInfo(query) {
  return request({
    url: '/goods/goods/info/page',
    method: 'get',
    params: query
  })
}

// 查询商品信息详细
export function getGoodsInfo(data) {
  return request({
    url: '/goods/goods/info/detail',
    method: 'get',
    params: data
  })
}

// 新增商品信息
export function addGoodsInfo(data) {
  return request({
    url: '/goods/goods/info/add',
    method: 'post',
    data: data
  })
}
// 同步商品信息
export function synWinGood(data) {
  return request({
    url: '/goods/goods/info/synWinGood',
    method: 'post',
    data: data
  })
}

// 修改商品信息
export function updateGoodsInfo(data) {
  return request({
    url: '/goods/goods/info/edit',
    method: 'post',
    data: data
  })
}
export function Delete(data) {
  return request({
    url: '/goods/sku/delete',
    method: 'post',
    data: data
  })
}

export function unmount(data) {
  return request({
    url: '/goods/goods/info/unmount',
    method: 'post',
    data: data
  })
}
export function batchUnmount(data) {
  return request({
    url: '/goods/goods/info/batchUnmount',
    method: 'post',
    data: data
  })
}
// 删除商品信息
export function delGoodsInfo(data) {
  return request({
    url: '/goods/goods/info/delete',
    method: 'post',
    data: data
  })
}

export function pushWDT(data) {
  return request({
    url: '/goods/goods/info/pushWDT',
    method: 'post',
    data: data
  })
}
